module.exports = require("./angular-base64.js");


//////////////////
// WEBPACK FOOTER
// angular-base64 (bower component)
// module id = 1483
// module chunks = 0